import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-onboarding-card',
  templateUrl: './onboarding-card.component.html',
  styleUrls: ['./onboarding-card.component.scss'],
})
export class OnboardingCardComponent {
  @Input()
  imageUrl!: string;

  @Input()
  title!: string;

  @Input()
  redirectTo!: string;

  @Input()
  disabled = false;

  @Input()
  checked = false;

  router = inject(Router);

  goToUrl(): void {
    if (this.disabled) {
      return;
    }

    this.router.navigateByUrl(this.redirectTo);
  }
}
